module.exports = __webpack_public_path__ + "static/media/location_helsinki.309619c4.jpg";